import React, { useState } from "react";
import { Link } from "react-router-dom";
import Institutions from "./institution";
import ManageTab from "./Manage/managetab";
import GroupList from "./grouplist";
import TypeList from "./typelist";

const GeneralTab = () => {

    const [activeTab, setActiveTab] = useState("Institutes");
    const roleId = localStorage.getItem('RoleId');

    const tabData = [
        {
            icon: <i className="fas fa-university" />,
            name: "Institutes",
            content: <Institutions />
        },
        {
            icon: <i className="fas fa-tasks" />,
            name: "Manage",
            content: <ManageTab />
        },
        ...((roleId != '7') ? [
            {
                icon: <i className="fas fa-archway" />,
                name: "Group",
                content: <GroupList />
            },
            {
                icon: <i className="fas fa-city" />,
                name: "Type",
                content: <TypeList />
            }
        ] : [])
    ]
    return (
        <>
            {/* <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">Institution</h3>
                            </div>
                            <div className="row d-flex align-items-center">
                                <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                    <div className="coach-court-list">
                                        <ul className="nav">
                                            {tabData.map((tab, i) => (
                                                <li key={i}>
                                                    <Link to="#"
                                                        className={tab.name === activeTab ? 'active' : ''}
                                                        onClick={() => setActiveTab(tab.name)}>
                                                        {tab.icon}  {tab.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    {tabData.map((tab, i) => (
                                        <div key={i} style={{ display: tab.name === activeTab ? 'block' : 'none' }}>
                                            {tab.content}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">Institution</h3>
                            </div>
                            <div className="row d-flex align-items-center">
                                <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                    <div className="coach-court-list">
                                        <ul className="nav">
                                            {tabData.map((tab, i) => (
                                                <li key={i}>
                                                    <Link
                                                        to="#"
                                                        className={tab.name === activeTab ? "active" : ""}
                                                        onClick={() => setActiveTab(tab.name)}
                                                    >
                                                        {tab.icon} {tab.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    {tabData
                                        .filter(tab => tab.name === activeTab)
                                        .map((tab, i) => (
                                            <div key={i}>{tab.content}</div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default GeneralTab;